import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

export abstract class SidePanelContainerBase {
  panelOpen: boolean;

  openPanel() {
    this.panelOpen = true;
  }

  closePanel() {
    this.panelOpen = false;
  }
}

export abstract class SidePanelComponentBase {
  @Input() panelOpen: boolean;
  @Output() panelClose = new EventEmitter<Event>();

  onPanelClose(event: Event) {
    event.preventDefault();
    this.panelClose.emit(event);
  }
}

@Component({
  selector: 'ot-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidePanelComponent extends SidePanelComponentBase {
  @Input() title: string;
}
